import logoSkanPay from "./../images/skanpay.png";

const menuItems = [
  { id: 1, title: "Presentation", anchor: "presentation" },
  { id: 2, title: "Prerequisites", anchor: "prerequisites" },
  { id: 3, title: "Direct Payment", anchor: "direct-payment" },
  { id: 4, title: "Deferred Payment", anchor: "deferred-payment" },
  { id: 5, title: "Redirected Payment", anchor: "redirected-payment" },
  { id: 6, title: "Payment Status", anchor: "payment-status" },
  { id: 7, title: "Callback URL", anchor: "callback-url" },
  { id: 8, title: "Balance", anchor: "merchand-solde" },
  { id: 9, title: "Client Refund", anchor: "client-refund" },
  { id: 10, title: "JSON Collections", anchor: "json-collections", url: "./SkanPay_API_Documentation.postman_collection.json" },
];

const NewDocsPage = () => {
  const scrollToSection = (anchor, url) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    } else {
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen overflow-y-auto" style={{ height: "100vh", overflowY: "auto" }}>
      {/* Header */}
      <div id="top" className="w-full h-16 drop-shadow bg-white sticky top-0 z-50">
        <div className="w-11/12 max-w-5xl mx-auto h-full flex items-center justify-between gap-5">
          <div>
            <img
              src={logoSkanPay}
              className="w-36"
              alt="logo SkanPay"
            />
          </div>
          {/* <div>
            <a href="https://skanpay.io/" target="_blank" rel="noopener noreferrer">
              <button className="bg-amber-500 text-white text-sm px-3 py-2 rounded-xl font-semibold hover:bg-amber-600 transition-colors">
                Create account
              </button>
            </a>
          </div> */}
        </div>
      </div>

      {/* Document Container */}
      <div className="py-10 max-w-5xl mx-auto px-4">
        <div
          className="bg-white w-full"
          style={{
            fontFamily: "'Times New Roman', Times, serif",
          }}
        >
          {/* Table of Contents */}
          <h2
            className="font-bold mb-6"
            style={{
              fontSize: "28px",
              color: "#2563a8",
            }}
          >
            Table of content
          </h2>

          {/* Menu Items with dotted lines */}
          <div className="space-y-3 mb-16">
            {menuItems.map((item) => (
              <div
                key={item.id}
                onClick={() => scrollToSection(item.anchor, item.url)}
                className="relative flex items-baseline cursor-pointer hover:bg-gray-50 py-1 px-2 -mx-2 rounded transition-colors"
                style={{ fontSize: "18px" }}
              >
                <span
                  className="font-bold w-8"
                  style={{ color: "#2563a8" }}
                >
                  {item.id}
                </span>
                <span
                  className="font-semibold hover:text-blue-700 transition-colors"
                  style={{ color: "#1f2937" }}
                >
                  {item.title}
                </span>
                <span
                  className="flex-1 mx-3 overflow-hidden"
                  style={{
                    borderBottom: "2px dotted #9ca3af",
                    marginBottom: "4px",
                  }}
                ></span>
                {item.url && <div className="absolute right-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-right-icon lucide-arrow-up-right"><path d="M7 7h10v10" /><path d="M7 17 17 7" /></svg></div>}
              </div>
            ))}
          </div>

          {/* Content Sections */}
          <div className="space-y-16">
            {/* 1. Presentation */}
            <section id="presentation" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                1. Presentation
              </h2>
              <p className="leading-relaxed mb-8" style={{ fontSize: "16px", color: "#4b5563" }}>
                SkanPayment is a payment gateway. This documentation describes how to use SkanPayment.
              </p>

              {/* Operators Section */}
              <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                <span style={{ color: "#f59e0b" }}>#</span> Operators
              </h3>
              <p className="leading-relaxed mb-4" style={{ fontSize: "16px", color: "#4b5563" }}>
                SkanPayment is connected to several operators, each implementing payment in a specific way.
                There are mainly three implementations:
              </p>

              <div className="mb-6 space-y-3" style={{ fontSize: "16px", color: "#4b5563" }}>
                <p>
                  <strong className="text-gray-800">Direct response payment:</strong> the response to the
                  payment request is found in the HTTP request response.
                </p>
                <p>
                  <strong className="text-gray-800">Deferred response payment:</strong> the response to the
                  payment request is made by calling a callback URL of the service using the API.
                </p>
                <p>
                  <strong className="text-gray-800">Redirected response payment:</strong> the response to the
                  payment request is made by calling a callback URL of the service using the API.
                </p>
              </div>

              <p className="leading-relaxed mb-4" style={{ fontSize: "16px", color: "#4b5563" }}>
                Each operator has a code that is used in the payment request. The following operators
                are integrated with SkanPayment:
              </p>

              <div className="space-y-2" style={{ fontSize: "16px", color: "#4b5563" }}>
                <p>
                  Orange Money CI (Direct response payment): <strong className="text-amber-500">OM_SKAN</strong>
                </p>
                <p>
                  MTN Money CI (Deferred response payment): <strong className="text-amber-500">MOMO_SKAN</strong>
                </p>
                <p>
                  Moov Money CI (Deferred response payment): <strong className="text-amber-500">MOOV_SKAN</strong>
                </p>
                <p>
                  Wave CI (Redirected response payment): <strong className="text-amber-500">WAVE_SKAN</strong>
                </p>
                <p>
                  Bank Card (Redirected response payment): <strong className="text-amber-500">CARTE_BANCAIRE_CINETPAY_SKAN</strong>
                </p>
              </div>
            </section>

            {/* 2. Prerequisites */}
            <section id="prerequisites" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                2. Prerequisites
              </h2>

              {/* User Account */}
              <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                <span style={{ color: "#f59e0b" }}>#</span> User Account
              </h3>
              <p className="leading-relaxed mb-8" style={{ fontSize: "16px", color: "#4b5563" }}>
                Every SkanPayment integrator must have an account beforehand. The account parameters
                (Login, Password) are provided by SkanPayment to the integrator.
              </p>

              {/* Merchant Service */}
              <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                <span style={{ color: "#f59e0b" }}>#</span> Merchant Service
              </h3>
              <p className="leading-relaxed mb-8" style={{ fontSize: "16px", color: "#4b5563" }}>
                A merchant service is a service for which the integrator would like to use SkanPayment
                as a payment method. Each service is configured on SkanPayment and is identified by a
                unique ID <strong className="text-gray-800">(serviceId)</strong>. This ID, provided by
                SkanPayment, is used in the payment request. Also, for each service, the integrator
                provides SkanPayment with a notification URL. This URL is called by SkanPayment via an
                HTTP POST request to notify of the success or failure of the payment request.
              </p>

              {/* Payment */}
              <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                <span style={{ color: "#f59e0b" }}>#</span> Payment
              </h3>
              <p className="leading-relaxed mb-8" style={{ fontSize: "16px", color: "#4b5563" }}>
                The payment request is made via an HTTP{" "}
                <span className="bg-teal-600 text-white px-2 py-0.5 rounded text-sm font-medium">POST</span>{" "}
                request. The request body is in{" "}
                <span className="bg-teal-600 text-white px-2 py-0.5 rounded text-sm font-medium">form-urlencoded</span>{" "}
                format. The response to the request is in{" "}
                <span className="bg-teal-600 text-white px-2 py-0.5 rounded text-sm font-medium">JSON</span>{" "}
                format and contains two entries: <strong className="text-gray-800">code</strong>, which
                defines the response status, and <strong className="text-gray-800">message</strong>, which
                describes the status.
              </p>

              {/* Authentication Token */}
              <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                <span style={{ color: "#f59e0b" }}>#</span> Authentication Token
              </h3>
              <p className="leading-relaxed mb-4" style={{ fontSize: "16px", color: "#4b5563" }}>
                All API requests require authentication using a Bearer Token. To obtain the token, log in to your administration interface using the access details provided by SkanPay. Then go to your services page and generate the token for the service you wish to integrate.
              </p>

              <p className="leading-relaxed" style={{ fontSize: "16px", color: "#4b5563" }}>
                Use this token in the <strong className="text-gray-800">X-Authorization</strong> header
                of all subsequent API requests with the format:{" "}
                <code className="bg-gray-100 px-2 py-1 rounded text-gray-700">Bearer {"<token>"}</code>
              </p>
            </section>

            {/* 3. Direct Payment */}
            <section id="direct-payment" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                3. Direct Payment
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                In the case of a direct response payment, the payment was successful if the response{" "}
                <strong className="text-gray-800">code</strong> equals 0. Any{" "}
                <strong className="text-gray-800">code</strong> value different from 0 indicates a
                payment failure. The cause of the failure is specified in the{" "}
                <strong className="text-gray-800">message</strong> of the response.
              </p>

              {/* Payment Process Diagram */}
              <div className="mb-10">
                <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                  <span style={{ color: "#f59e0b" }}>#</span> Payment Process
                </h3>
                <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                  This process is used to request a payment from a mobile money wallet. It involves:
                </p>

                <div className="flex flex-col items-center py-6">
                  {/* Step 1 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">1. The merchant initiates the payment request via the SkanPayment API with the OTP code generated by the customer.</p>
                  </div>

                  {/* Arrow 1 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 2 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">2. Once the code has been validated, the customer's mobile money account is debited.</p>
                  </div>
                </div>
              </div>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">https://paiement.skanci.com/mobilepayment/payer</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">Content-Type</span>
                    <span className="text-gray-600">application/x-www-form-urlencoded</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">X-Authorization</span>
                    <span className="text-gray-600">Bearer {"<token>"}</span>
                  </div>
                </div>
              </div>

              {/* Body Parameters Table */}
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-4">BODY</p>
              <div className="overflow-x-auto">
                <table className="w-full" style={{ borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#fef2f2" }}>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Parameter</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Value</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { param: "codeOperateur", value: "OM_SKAN", desc: "Operator code linked to the service" },
                      { param: "token", value: "XXXXXX", desc: "If codeOperateur = OM_SKAN, the token is required and is generated using the syntax #144*82#" },
                      { param: "reference", value: "YYYYYYYYY", desc: "A reference is a unique number not provided by the operator, associated with the current operation" },
                      { param: "numero", value: "XXXXXXXXXX", desc: "Phone number to debit" },
                      { param: "montant", value: "MONTANT", desc: "Amount associated with the transaction or operation" },
                      { param: "typeOperateur", value: "NON_REDIRIGE", desc: "Value must remain NON_REDIRIGE" },
                      { param: "nom", value: "NOM", desc: "Customer name making the payment (optional)" },
                      { param: "email", value: "xxx@gmail.com", desc: "Customer email address making the payment (optional)" },
                      { param: "numeroClient", value: "XXXXXXXX", desc: "Customer number making the payment (optional)" },
                    ].map((row, index) => (
                      <tr key={index}>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#991b1b", fontWeight: "500" }}>{row.param}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.value}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
  --request POST "https://paiement.skanci.com/mobilepayment/payer" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "codeOperateur=OM_SKAN" \\
  --data-urlencode "token=2834" \\
  --data-urlencode "reference=0199ce75-9a65-7768-9ec0-941272d5ed10" \\
  --data-urlencode "montant=5" \\
  --data-urlencode "typeOperateur=NON_REDIRIGE" \\
  --data-urlencode "nom=TANFOLO JOEL" \\
  --data-urlencode "email=joel.tanfolo@skanci.com" \\
  --data-urlencode "numeroClient=0500000000" \\
  --data-urlencode "numero=0700000000" \\
  --data-urlencode "urlRetour=https://skanci.com"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 0,
  "message": "Paiement effectué avec succès"
}`}
                  </pre>
                </div>
              </div>
            </section>

            {/* 4. Deferred Payment */}
            <section id="deferred-payment" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                4. Deferred Payment
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                In the case of a deferred response payment, after the payment request, SkanPayment
                waits for the payment validation by the customer and the{" "}
                <strong className="text-gray-800">code</strong> is set to 10. Any{" "}
                <strong className="text-gray-800">code</strong> value different from 10 indicates a
                payment failure. The cause of the failure is specified in the{" "}
                <strong className="text-gray-800">message</strong> of the response.
              </p>

              {/* Payment Process Diagram */}
              <div className="mb-10">
                <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                  <span style={{ color: "#f59e0b" }}>#</span> Payment Process
                </h3>
                <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                  This process is used to request a deferred payment from a mobile money wallet. It involves:
                </p>

                <div className="flex flex-col items-center py-6">
                  {/* Step 1 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">1. The merchant sends a payment request via the SkanPayment API.</p>
                  </div>

                  {/* Arrow 1 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 2 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">2. The customer receives an SMS or push notification to confirm the payment.</p>
                  </div>

                  {/* Arrow 2 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 3 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">3. The customer confirms the payment and their mobile money account is debited.</p>
                  </div>

                  {/* Arrow 3 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 4 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">4. SkanPayment notifies the merchant via the notification URL (callback).</p>
                  </div>
                </div>
              </div>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">https://paiement.skanci.com/mobilepayment/payer</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">Content-Type</span>
                    <span className="text-gray-600">application/x-www-form-urlencoded</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">X-Authorization</span>
                    <span className="text-gray-600">Bearer {"<token>"}</span>
                  </div>
                </div>
              </div>

              {/* Body Parameters Table */}
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-4">BODY</p>
              <div className="overflow-x-auto mb-8">
                <table className="w-full" style={{ borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#fef2f2" }}>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Parameter</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Value</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { param: "codeOperateur", value: "MOOV_SKAN, MOMO_SKAN", desc: "Operator code linked to the service, in this case 'MOOV_SKAN', 'MOMO_SKAN' for Moov money and MTN money" },
                      { param: "reference", value: "YYYYYYYYY", desc: "A reference is a unique number not provided by the operator, associated with the current operation" },
                      { param: "numero", value: "XXXXXXXXXX", desc: "Phone number to debit" },
                      { param: "montant", value: "MONTANT", desc: "Amount associated with the transaction" },
                      { param: "typeOperateur", value: "NON_REDIRIGE", desc: "Value must remain NON_REDIRIGE" },
                      { param: "nom", value: "NOM", desc: "Customer name (optional)" },
                      { param: "email", value: "xxx@gmail.com", desc: "Customer email address (optional)" },
                      { param: "numeroClient", value: "XXXXXXXX", desc: "Another customer number (optional)" },
                    ].map((row, index) => (
                      <tr key={index}>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#991b1b", fontWeight: "500" }}>{row.param}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.value}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Additional Info */}
              <p className="leading-relaxed mb-4" style={{ fontSize: "16px", color: "#4b5563" }}>
                After submitting the payment request, the customer receives an SMS or a push notification
                for payment validation.
              </p>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                Once the payment is validated by the customer, the notification URL provided by the service
                is called by SkanPayment via an HTTP POST request{" "}
                <span className="bg-teal-600 text-white px-2 py-0.5 rounded text-sm font-medium">JSON</span>
              </p>

              {/* Callback URL */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">Url [urlNotificationService]</code>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
  --request POST "https://paiement.skanci.com/mobilepayment/payer" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "codeOperateur=MOMO_SKAN" \\
  --data-urlencode "reference=0199ce75-9a65-7768-9ec0-941272d5ed10" \\
  --data-urlencode "montant=5" \\
  --data-urlencode "typeOperateur=NON_REDIRIGE" \\
  --data-urlencode "nom=TANFOLO JOEL" \\
  --data-urlencode "email=joel.tanfolo@skanci.com" \\
  --data-urlencode "numeroClient=0500000000" \\
  --data-urlencode "numero=0700000000" \\
  --data-urlencode "urlRetour=https://skanci.com"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 10,
  "message": "Payment pending validation"
}`}
                  </pre>
                </div>
              </div>
            </section>

            {/* 5. Redirected Payment */}
            <section id="redirected-payment" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                5. Redirected Payment
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                In the case of a redirected response payment, after the payment request, SkanPayment
                waits for the payment validation by the customer, the{" "}
                <strong className="text-gray-800">code</strong> is set to 20 and the{" "}
                <strong className="text-gray-800">message</strong> contains the payment validation URL.
                Any <strong className="text-gray-800">code</strong> value different from 20 indicates a
                payment failure. The cause of the failure is specified in the{" "}
                <strong className="text-gray-800">message</strong> of the response.
              </p>

              {/* Payment Process Diagram */}
              <div className="mb-10">
                <h3 className="flex items-center gap-2 text-xl font-bold mb-4" style={{ color: "#1f2937" }}>
                  <span style={{ color: "#f59e0b" }}>#</span> Payment Process
                </h3>
                <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                  This process is used to request a redirected payment (Wave, Bank Card). It involves:
                </p>

                <div className="flex flex-col items-center py-6">
                  {/* Step 1 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">1. The merchant sends a payment request via the SkanPayment API.</p>
                  </div>

                  {/* Arrow 1 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 2 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">2. SkanPayment returns a payment URL (code 20)</p>
                  </div>

                  {/* Arrow 2 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 3 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">3. The customer is redirected to the URL to make the payment.</p>
                  </div>

                  {/* Arrow 3 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 4 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">4. After validation, the customer is redirected to the return URL (urlRetour).</p>
                  </div>

                  {/* Arrow 4 */}
                  <div className="flex flex-col items-center my-2">
                    <div className="w-0.5 h-10" style={{ backgroundColor: "#1e4a6d" }}></div>
                    <div
                      className="w-0 h-0"
                      style={{
                        borderLeft: "8px solid transparent",
                        borderRight: "8px solid transparent",
                        borderTop: "10px solid #1e4a6d"
                      }}
                    ></div>
                  </div>

                  {/* Step 5 */}
                  <div
                    className="w-80 py-6 px-4 rounded-2xl text-center text-white"
                    style={{ backgroundColor: "#1e4a6d" }}
                  >
                    <p className="font-medium">5. SkanPayment notifies the merchant via the notification URL (callback).</p>
                  </div>
                </div>
              </div>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">https://paiement.skanci.com/mobilepayment/payer</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">Content-Type</span>
                    <span className="text-gray-600">application/x-www-form-urlencoded</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">X-Authorization</span>
                    <span className="text-gray-600">Bearer {"<token>"}</span>
                  </div>
                </div>
              </div>

              {/* Body Parameters Table */}
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-4">BODY</p>
              <div className="overflow-x-auto mb-8">
                <table className="w-full" style={{ borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#fef2f2" }}>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Parameter</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Value</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { param: "codeOperateur", value: "WAVE_SKAN", desc: "Operator code linked to the service, in this case 'WAVE_SKAN' for Wave or 'CARTE_BANCAIRE_CINETPAY_SKAN' for bank card" },
                      { param: "reference", value: "YYYYYYYYY", desc: "Unique number provided by the operator, associated with the current operation" },
                      { param: "numero", value: "XXXXXXXXXX", desc: "Phone number to debit" },
                      { param: "montant", value: "MONTANT", desc: "Amount associated with the transaction or operation (100 FR minimum for bank card payments)" },
                      { param: "typeOperateur", value: "REDIRIGE", desc: "Value must remain REDIRIGE" },
                      { param: "nom", value: "NOM", desc: "Customer name making the payment (optional)" },
                      { param: "email", value: "xxx@gmail.com", desc: "Customer email address (optional)" },
                      { param: "numeroClient", value: "XXXXXXXX", desc: "Customer number making the payment (optional)" },
                      { param: "urlRetour", value: "XXXX", desc: "The customer is redirected to this URL after payment validation. This URL must be HTTPS" },
                    ].map((row, index) => (
                      <tr key={index}>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#991b1b", fontWeight: "500" }}>{row.param}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.value}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
  --request POST "https://paiement.skanci.com/mobilepayment/payer" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "codeOperateur=WAVE_SKAN" \\
  --data-urlencode "reference=0199ce75-9a65-7768-9ec0-941272d5ed10" \\
  --data-urlencode "montant=5" \\
  --data-urlencode "typeOperateur=REDIRIGE" \\
  --data-urlencode "nom=TANFOLO JOEL" \\
  --data-urlencode "email=joel.tanfolo@skanci.com" \\
  --data-urlencode "numeroClient=0500000000" \\
  --data-urlencode "numero=0700000000" \\
  --data-urlencode "urlRetour=https://skanci.com"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 20,
  "message": "https://pay.wave.com/c/{...}"
}`}
                  </pre>
                </div>
              </div>
            </section>

            {/* 6. Payment Status */}
            <section id="payment-status" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                6. Payment Status
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                This API allows you to check the status of a payment. The payment was successful
                if the response <strong className="text-gray-800">code</strong> equals 0. Any{" "}
                <strong className="text-gray-800">code</strong> value different from 0 indicates a
                payment failure. The cause of the failure is specified in the{" "}
                <strong className="text-gray-800">message</strong> of the response.
              </p>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">https://skanci.com/mobilepayment/verifierstatutpaiement</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">Content-Type</span>
                    <span className="text-gray-600">application/x-www-form-urlencoded</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">X-Authorization</span>
                    <span className="text-gray-600">Bearer {"<token>"}</span>
                  </div>
                </div>
              </div>

              {/* Body Parameters Table */}
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-4">BODY</p>
              <div className="overflow-x-auto mb-8">
                <table className="w-full" style={{ borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#fef2f2" }}>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Parameter</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Value</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { param: "reference", value: "YYYYYYYYYY", desc: "The payment reference" },
                    ].map((row, index) => (
                      <tr key={index}>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#991b1b", fontWeight: "500" }}>{row.param}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.value}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
  --request POST "https://skanci.com/mobilepayment/verifierstatutpaiement" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "reference=0199ce75-9a65-7768-9ec0-941272d5ed10"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 0,
  "message": "Paiement effectué avec succès"
}`}
                  </pre>
                </div>
              </div>
            </section>

            {/* 7. Callback URL */}
            <section id="callback-url" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                7. Callback URL
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                For payments made via MTN Money, Moov Money, and Wave, a callback URL is called to notify the partner of the status of the current payment. This URL is configured through the administration interface provided by SkanPay. The payment is successful if the{" "}
                <strong className="text-gray-800">code</strong> is 0; otherwise, it is a failure. <br /> The request header contains the partner's{" "}
                <strong className="text-gray-800">bearerToken</strong> to authenticate its origin. The token is found in the{" "}
                <strong className="text-gray-800">X-Authorization</strong> and{" "}
                <strong className="text-gray-800">HTTP_X_AUTHORIZATION</strong> variables.
              </p>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">https://yourdomainname.com/callbackurl</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="w-full border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-56">X-Authorization</span>
                    <span className="text-gray-600">bearerToken</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-56">HTTP_X_AUTHORIZATION</span>
                    <span className="text-gray-600">bearerToken</span>
                  </div>
                </div>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
--request POST "https://yourdomainname.com/callbackurl" \\
--header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
--header "HTTP_X_AUTHORIZATION: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
--header "Content-Type: application/json"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 0,
  "message": ""
}`}
                  </pre>
                </div>
              </div>
            </section>

            {/* 8. Balance */}
            <section id="merchand-solde" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                8. Balance
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                This API allows you to check the balance of a service. The balance is returned
                in the response of the request.
              </p>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">GET</span>
                <code className="text-gray-700">https://skanci.com/mobilepayment/solde</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">Content-Type</span>
                    <span className="text-gray-600">application/x-www-form-urlencoded</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">X-Authorization</span>
                    <span className="text-gray-600">Bearer {"<token>"}</span>
                  </div>
                </div>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
  --request GET "https://skanci.com/mobilepayment/solde" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 0,
  "message": 1000
}`}
                  </pre>
                </div>
              </div>
            </section>

            {/* 9. Client Refund */}
            <section id="client-refund" className="scroll-mt-24">
              <h2
                className="font-bold mb-6 pb-2 border-b-2"
                style={{ fontSize: "24px", color: "#2563a8", borderColor: "#2563a8" }}
              >
                9. Client Refund
              </h2>
              <p className="leading-relaxed mb-6" style={{ fontSize: "16px", color: "#4b5563" }}>
                In the case of a client refund, the refund was successful if the response{" "}
                <strong className="text-gray-800">code</strong> equals 0. Any{" "}
                <strong className="text-gray-800">code</strong> value different from 0 indicates a
                refund failure. The cause of the failure is specified in the{" "}
                <strong className="text-gray-800">message</strong> of the response.
              </p>

              {/* API Endpoint */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center gap-3">
                <span className="bg-green-500 text-white px-3 py-1 rounded text-sm font-bold">POST</span>
                <code className="text-gray-700">https://skanci.com/mobilepayment/reverser</code>
              </div>

              {/* Headers */}
              <div className="mb-6">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">HEADERS</p>
                <div className="border-t border-gray-200 py-3 space-y-2">
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">Content-Type</span>
                    <span className="text-gray-600">application/x-www-form-urlencoded</span>
                  </div>
                  <div className="flex">
                    <span className="font-semibold text-gray-800 w-40">X-Authorization</span>
                    <span className="text-gray-600">Bearer {"<token>"}</span>
                  </div>
                </div>
              </div>

              {/* Body Parameters Table */}
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-4">BODY</p>
              <div className="overflow-x-auto mb-8">
                <table className="w-full" style={{ borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#fef2f2" }}>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Parameter</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Value</th>
                      <th style={{ border: "1px solid #b91c1c", padding: "12px 16px", textAlign: "left", color: "#991b1b", fontWeight: "600" }}>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { param: "codeOperateur", value: "WAVE_SKAN", desc: "Operator code linked to the service" },
                      { param: "reference", value: "YYYYYYYYYY", desc: "A reference is a unique number not provided by the operator, associated with the current operation" },
                      { param: "numero", value: "XXXXXXXXXX", desc: "Phone number receiving the money" },
                      { param: "montant", value: "MONTANT", desc: "Amount to refund" },
                    ].map((row, index) => (
                      <tr key={index}>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#991b1b", fontWeight: "500" }}>{row.param}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.value}</td>
                        <td style={{ border: "1px solid #b91c1c", padding: "12px 16px", color: "#7f1d1d" }}>{row.desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Code Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`curl --location \\
  --request POST "https://skanci.com/mobilepayment/reverser" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "codeOperateur=WAVE_SKAN" \\
  --data-urlencode "reference=0199ce75-9a65-7768-9ec0-941272d5ed10" \\
  --data-urlencode "montant=5" \\
  --data-urlencode "numero=0700000000"`}
                  </pre>
                </div>
              </div>

              {/* Response Example */}
              <div className="mt-8">
                <p className="text-base font-semibold text-gray-800 mb-2 border-b border-gray-300 pb-1">Response Example :</p>
                <div className="bg-gray-800 rounded-lg p-4 overflow-x-auto">
                  <pre className="text-sm text-gray-100 font-mono whitespace-pre-wrap">
                    {`{
  "code": 0,
  "message": "Paiement effectué avec succès"
}`}
                  </pre>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 bg-blue-700 hover:bg-blue-800 text-white p-3 rounded-full shadow-lg transition-all hover:scale-110 z-50"
        title="Back to top"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 15l7-7 7 7"
          />
        </svg>
      </button>
    </div>
  );
};

export default NewDocsPage;
